export function error(field, message) {
  return {
    field: field,
    message: message,
  };
}
